// extracted by mini-css-extract-plugin
export var dropdownButton = "_3j-0";
export var fullWidthDropdownButton = "_3j-1";
export var icon = "_3j-3";
export var iconPlaceholder = "_3j-2";
export var menuItemRow = "_3j-5";
export var shortcutContainer = "_3j-4";